import React, { useEffect, useRef, useState } from 'react';
import { Trans, withI18n } from '@lingui/react';
import Collapsible from 'react-collapsible';
import styled from 'styled-components';
import { tabletBreakpoint, mobileBreakpoint } from '~/styles/common';

const CollapsibleElement = ({ heading, children, id }) => {
    const triggerRef = useRef(null);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(id === window.location.hash.replace('#', ''))
    }, [])


    const onClose = () => {
        triggerRef.current.classList.remove('opened')
    }
    const onOpen = () => {
        triggerRef.current.classList.add('opened')
        window.location.hash = id;
    }

    return (
        <>
            <Collapsible
                trigger={<Trigger id={id} ref={triggerRef}> {heading} </Trigger>}
                onOpening={onOpen}
                onClosing={onClose}
                open={open}
                easing="linear"
                transitionTime={300}
            >
                <AnswerWrapper>{children}</AnswerWrapper>
            </Collapsible>
        </>
    );
};

export default withI18n()(CollapsibleElement);

const Trigger = styled.div`
    padding: 20px 40px 15px 20px;
    font-weight: bold;
    font-size: 22px;
    line-height: 1.5em;
    letter-spacing: 0.3px;
    color: #000000;
    cursor: pointer;
    position: relative;
    border-top: 1px solid #edf2f4;
    width: 100%;

    @media (max-width: ${tabletBreakpoint}) {
        padding: 10px 35px  20px 20px;
    }

    &:hover {
        color: #21c298
    }

    &.opened {
        width: 100%;
        color: #21c298;
        scroll-margin: 90px;    
    }

    &::after {
        transform: rotate(45deg);
        content: '';
        height: 12px;
        width: 12px;
        border-bottom: 2px solid black;
        border-right: 2px solid black;
        margin-left: auto;
        position: absolute;
        right: 10px;
        top: 25px;
        display: block;
        transition: transform 300ms;
    }

    &.opened::after {
        transform: rotate(225deg);
        right: 10px;
        top: 29px;
    }
`;

const AnswerWrapper = styled.div`
    padding: 0 10px 60px 40px;
    font-size: 18px;
    line-height: 1.8em;
    letter-spacing: 0.3px;

    p{
        font-size: 18px;
    }

    @media (max-width: ${tabletBreakpoint}) {
        padding: 0 10px  20px 20px;
    }

    @media (max-width: ${mobileBreakpoint}) {
        font-size: 16px;
        
        p{
            font-size: 16px;
        }
    }
`;
